import type { DataWithLastModified, FigureData } from './specification-data-service';

export const SpecificationFigureService = Symbol.for('SpecificationFigureService');

/**
 * 专利说明书附图服务接口
 */
export interface SpecificationFigureService {
    /**
     * 重新加载附图数据
     * @returns Promise<DataWithLastModified<FigureData[]>> 返回附图数据和最后修改时间
     */
    reloadFigures(): Promise<DataWithLastModified<FigureData[]>>;
}
